module.exports = __webpack_public_path__ + "img/play_button.95657dfc.png";